import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const StyledModal = styled(Modal)`
  .modal-content {
    background-color: #ffffff;
    box-shadow: inset 0 4px 0 ${(p) => p.theme.color.primary},
      0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    border-radius: ${(p) => p.theme.radius.md};
    border: none;
  }
  .modal-header {
    border-bottom: 1px solid ${(p) => p.theme.color.border};
    padding: calc(${(p) => p.theme.spacing.md} + 4px)
      ${(p) => p.theme.spacing.md} ${(p) => p.theme.spacing.md};
  }
  .modal-body {
    padding: ${(p) => p.theme.spacing.md};
    overflow: visible;
  }
  .modal-footer {
    border-top: 1px solid ${(p) => p.theme.color.border};
    padding: ${(p) => p.theme.spacing.sm} ${(p) => p.theme.spacing.md};
  }
`;

const ModalTitle = styled.span`
  font-family: ${(p) => p.theme.font.family};
  font-size: ${(p) => p.theme.font.sizeLg};
  font-weight: ${(p) => p.theme.font.weightSemibold};
  color: ${(p) => p.theme.color.primary};
  line-height: 1.2;
`;

const LeadText = styled.p`
  font-family: ${(p) => p.theme.font.family};
  font-size: ${(p) => p.theme.font.sizeMd};
  color: ${(p) => p.theme.color.text};
  line-height: 1.5;
  margin: 0 0 ${(p) => p.theme.spacing.md} 0;
`;

const InfoCard = styled.div`
  background: ${(p) => p.theme.color.surfaceAlt};
  border-radius: ${(p) => p.theme.radius.md};
  padding: ${(p) => p.theme.spacing.md};
  display: flex;
  flex-direction: column;
  gap: ${(p) => p.theme.spacing.sm};
`;

const HandRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${(p) => p.theme.spacing.md};
`;

const HandLabel = styled.span`
  font-family: ${(p) => p.theme.font.family};
  font-size: ${(p) => p.theme.font.sizeSm};
  color: ${(p) => p.theme.color.textMuted};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const HandValue = styled.span`
  font-family: ${(p) => p.theme.font.family};
  font-size: ${(p) => p.theme.font.sizeMd};
  font-weight: ${(p) => p.theme.font.weightSemibold};
  color: ${(p) => p.theme.color.primary};
`;

const HandMismatchModal = ({ show, onHide, onConfirm, customerHand, specHand }) => {
  const { t } = useTranslation();

  return (
    <StyledModal show={show} onHide={onHide} size="md" centered>
      <Modal.Header closeButton>
        <ModalTitle>{t("message.confirm.handMismatchTitle")}</ModalTitle>
      </Modal.Header>
      <Modal.Body>
        <LeadText>{t("message.confirm.handMismatchBody")}</LeadText>
        <InfoCard>
          <HandRow>
            <HandLabel>{t("form.label.customer_hand")}</HandLabel>
            <HandValue>{customerHand ? t(customerHand) : "—"}</HandValue>
          </HandRow>
          <HandRow>
            <HandLabel>{t("form.label.specsheet_hand")}</HandLabel>
            <HandValue>{specHand ? t(specHand) : "—"}</HandValue>
          </HandRow>
        </InfoCard>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onHide}>
          {t("message.confirm.cancel")}
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          {t("message.confirm.calculateAnyway")}
        </Button>
      </Modal.Footer>
    </StyledModal>
  );
};

export default HandMismatchModal;
